<script setup lang="ts">
import { $dayjs } from '@/utils/dayjs'
import type { HouseReview } from '~/types/house/types'

const props = withDefaults(
  defineProps<{
    activeTruncate?: boolean
    review?: HouseReview
  }>(),
  {
    activeTruncate: true,
    review: () =>
      ({
        quote: '',
        stay: '',
        username: '',
      }) as HouseReview,
  },
)
defineEmits<{ 'click-more': [] }>()

const { locale } = useI18n()

$dayjs.locale(locale.value)

const limitToTruncate = 125

const isTruncate = computed(() => props.review?.quote?.length > limitToTruncate)
const ellipsizeQuote = computed(() =>
  isTruncate.value
    ? props.review?.quote.substring(0, limitToTruncate).concat('...')
    : (props.review?.quote ?? ''),
)
</script>

<template>
  <div>
    <div class="mb-4 flex items-center justify-between">
      <span class="text-md font-bold text-secondary-400">
        {{ review.username }}
      </span>
      <span class="text-xs font-semibold capitalize text-gray-500">
        {{ $dayjs(review.stay, 'YYYY-MM-DD').format('MMMM YYYY') }}
      </span>
    </div>
    <div class="italic">
      {{ activeTruncate ? ellipsizeQuote : review.quote }}
    </div>

    <BaseButton
      v-show="activeTruncate && isTruncate"
      color="black"
      variant="link"
      class="mt-4 !text-md md:mt-7"
      @click="$emit('click-more')"
    >
      {{ $t('house.reviews.readMore') }}
    </BaseButton>
  </div>
</template>
